import React from 'react';

import Logo from '../assets/ASlogo.png'

const Header = () => {
  return (
    <header className="py-8" id="Home">
      <div className="container mx-auto">
        <div className="flex justify-between items-center">
          <a href="https://www.linkedin.com/in/arun2003as">
            <img src={Logo} alt="" width="100px" height="100px"/>
          </a>

          <button onClick={() => {
    window.location.href="https://www.linkedin.com/in/ArunkumarA03";}}
          className="btn btn-sm">Work with me</button>
        </div>
      </div>
    </header>
  );
};

export default Header;
